import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Download, Check } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';

const ProductDetail = () => {
  const { productId } = useParams();
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);
  const [selectedImage, setSelectedImage] = useState(0);

  // Product data with actual technical specifications
  const products = {
    e1: {
      nameKey: 'e1Name',
      descriptionKey: 'e1Desc',
      images: [
        'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/v2pjvjqw_Photoroom_20251103_233504.png',
        'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/j7g4x7pp_Photoroom_20251103_231807.png',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/y6ssicrh_Photoroom_20251103_233459.png'
      ],
      catalogUrl: 'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/nook83ge_ElereinT1a%20color%20change.pdf',
      specs: {
        workingWidth: '52',
        vacuumWidth: '52',
        solutionTank: '6',
        dirtyWaterTank: '9',
        noise: '63',
        weight: '24',
        dimensions: '52 x 41 x 124',
        power: 'Li-Ion',
        driveMotor: 'No',
        workingTime: '1h'
      }
    },
    e30: {
      nameKey: 'e30Name',
      descriptionKey: 'e30Desc',
      images: [
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/t7w5h6ni_e30%20main.jpeg',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/c4b1ugwc_WhatsApp%20Image%202025-12-06%20at%2013.15.27.jpeg',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/bo5neehq_e30%2011.jpeg',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/r0w0e4ot_e30%202.jpeg'
      ],
      catalogUrl: '/catalog',
      specs: {
        workingWidth: '30',
        vacuumWidth: '45',
        solutionTank: '30',
        dirtyWaterTank: '30',
        noise: '65',
        weight: '-',
        dimensions: '-',
        power: 'Batt',
        driveMotor: 'No',
        workingTime: '3-5h'
      }
    },
    e60: {
      nameKey: 'e60Name',
      descriptionKey: 'e60Desc',
      images: [
        'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/orym4xwj_Photoroom_20251103_231840.png',
        'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/xn5ghotx_e60%20havaliman%C4%B1.jpg',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/4psqnr6e_Main-10.png',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/2diyeh2h_Main-17.png',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/zwk1syu0_Main-20.png',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/atcgo3w2_Main-22.png',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/d0krnww2_Main-27.png'
      ],
      catalogUrl: '/catalog',
      specs: {
        workingWidth: '51',
        vacuumWidth: '75',
        solutionTank: '50',
        dirtyWaterTank: '50',
        noise: '67',
        weight: '100',
        dimensions: '116 x 48 x 100',
        power: 'Batt',
        driveMotor: 'No',
        workingTime: '3-5h'
      }
    },
    e100: {
      nameKey: 'e100Name',
      descriptionKey: 'e100Desc',
      images: [
        'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/chz8lnrn_Photoroom_20251103_231824.png',
        'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/l8v19u16_Photoroom_20251103_231824.png',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/jwbunz1r_Main-11.png',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/uexxw3rq_Main-12.png',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/15znapy3_Main-19.png',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/iu00m6xq_Main-22.png'
      ],
      catalogUrl: '/catalog',
      specs: {
        workingWidth: '70',
        vacuumWidth: '100',
        solutionTank: '110',
        dirtyWaterTank: '120',
        noise: '67',
        weight: '220',
        dimensions: '155 x 80 x 120',
        power: 'Batt',
        driveMotor: 'Yes',
        workingTime: '4h'
      }
    },
    e130: {
      nameKey: 'e130Name',
      descriptionKey: 'e130Desc',
      images: [
        'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/j11j0d0c_Photoroom_20251103_231814.png',
        'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/bb2qxhis_Photoroom_20251103_231814.png',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/3x9qtq1l_Main-4.jpg',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/rq5v063s_Main-5.jpg',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/g6jqwzas_Main-8.jpg',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/2cg70rul_Main-10.jpg',
        'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/t3vuhe5u_Main-13.jpg'
      ],
      catalogUrl: '/catalog',
      specs: {
        workingWidth: '86',
        vacuumWidth: '100',
        solutionTank: '130',
        dirtyWaterTank: '130',
        noise: '67',
        weight: '330',
        dimensions: '155 x 90 x 136',
        power: 'Batt',
        driveMotor: 'Yes',
        workingTime: '4h'
      }
    },
    e250: {
      nameKey: 'e250Name',
      descriptionKey: 'e250Desc',
      images: [
        'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/c5mqf1mt_E250%20depo.jpg',
        'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/xgvtodjh_Photoroom_20251103_231831.png'
      ],
      catalogUrl: '/catalog',
      specs: {
        workingWidth: '100',
        vacuumWidth: '120',
        solutionTank: '250',
        dirtyWaterTank: '250',
        noise: '69',
        weight: '-',
        dimensions: '-',
        power: 'Batt',
        driveMotor: 'Yes',
        workingTime: '5-6h'
      }
    }
  };

  const product = products[productId];

  if (!product) {
    return (
      <div className="min-h-screen pt-20 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-3xl font-bold mb-4">{language === 'tr' ? 'Ürün Bulunamadı' : language === 'en' ? 'Product Not Found' : language === 'de' ? 'Produkt nicht gefunden' : 'المنتج غير موجود'}</h1>
          <Link to="/professional">
            <Button className="bg-sky-500 hover:bg-sky-600 text-white">
              <ArrowLeft className="w-4 h-4 mr-2" />
              {language === 'tr' ? 'Ürünlere Dön' : language === 'en' ? 'Back to Products' : language === 'de' ? 'Zurück zu Produkten' : 'العودة إلى المنتجات'}
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  // Technical specification labels by language
  const specLabels = {
    tr: {
      workingWidth: 'Çalışma Genişliği',
      vacuumWidth: 'Vakum Genişliği',
      solutionTank: 'Solüsyon tank',
      dirtyWaterTank: 'Kirli su tank',
      noise: 'Ses',
      weight: 'Ağırlık batarya dahil',
      dimensions: 'Ölçüler(cm)',
      power: 'Güç',
      driveMotor: 'Yürüyüş Motor',
      workingTime: 'Çalışma saati'
    },
    en: {
      workingWidth: 'Working Width',
      vacuumWidth: 'Vacuum Width',
      solutionTank: 'Solution Tank',
      dirtyWaterTank: 'Dirty Water Tank',
      noise: 'Noise',
      weight: 'Weight incl. Battery',
      dimensions: 'Dimensions(cm)',
      power: 'Power',
      driveMotor: 'Drive Motor',
      workingTime: 'Working Time'
    },
    de: {
      workingWidth: 'Arbeitsbreite',
      vacuumWidth: 'Saugbreite',
      solutionTank: 'Frischwassertank',
      dirtyWaterTank: 'Schmutzwassertank',
      noise: 'Geräusch',
      weight: 'Gewicht inkl. Batterie',
      dimensions: 'Abmessungen(cm)',
      power: 'Leistung',
      driveMotor: 'Fahrmotor',
      workingTime: 'Arbeitszeit'
    },
    ar: {
      workingWidth: 'عرض العمل',
      vacuumWidth: 'عرض الشفط',
      solutionTank: 'خزان المحلول',
      dirtyWaterTank: 'خزان الماء المتسخ',
      noise: 'الضوضاء',
      weight: 'الوزن مع البطارية',
      dimensions: 'الأبعاد(سم)',
      power: 'الطاقة',
      driveMotor: 'محرك القيادة',
      workingTime: 'وقت العمل'
    }
  };

  const currentLabels = specLabels[language] || specLabels['tr'];

  return (
    <div className="min-h-screen pt-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Back Button */}
        <Link to="/professional">
          <Button variant="outline" className="mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('backButton')}
          </Button>
        </Link>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Image Gallery */}
          <div>
            <div className="bg-white rounded-lg overflow-hidden shadow-lg mb-4">
              <img
                src={product.images[selectedImage]}
                alt={t(product.nameKey)}
                className="w-full h-96 object-contain bg-gray-100"
              />
            </div>
            <div className="grid grid-cols-4 gap-4">
              {product.images.map((image, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedImage(index)}
                  className={`bg-white rounded-lg overflow-hidden shadow ${
                    selectedImage === index ? 'ring-4 ring-sky-500' : ''
                  }`}
                >
                  <img
                    src={image}
                    alt={`${t(product.nameKey)} ${index + 1}`}
                    className="w-full h-24 object-contain bg-gray-100"
                  />
                </button>
              ))}
            </div>
          </div>

          {/* Product Info */}
          <div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              {t(product.nameKey)}
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              {t(product.descriptionKey)}
            </p>

            {/* Technical Specifications Table */}
            <div className="bg-white rounded-lg shadow-lg p-6 mb-6 overflow-x-auto">
              <h2 className="text-2xl font-bold mb-6">
                {language === 'tr' ? 'Teknik Özellikler' : language === 'en' ? 'Technical Specifications' : language === 'de' ? 'Technische Daten' : 'المواصفات الفنية'}
              </h2>
              <table className="w-full border-collapse">
                <tbody>
                  <tr className="border-b border-gray-200">
                    <td className="py-3 px-4 font-semibold text-gray-700 bg-gray-50">{currentLabels.workingWidth}</td>
                    <td className="py-3 px-4 text-center text-gray-600">cm</td>
                    <td className="py-3 px-4 text-center text-gray-900 font-medium">{product.specs.workingWidth}</td>
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="py-3 px-4 font-semibold text-gray-700 bg-gray-50">{currentLabels.vacuumWidth}</td>
                    <td className="py-3 px-4 text-center text-gray-600">cm</td>
                    <td className="py-3 px-4 text-center text-gray-900 font-medium">{product.specs.vacuumWidth}</td>
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="py-3 px-4 font-semibold text-gray-700 bg-gray-50">{currentLabels.solutionTank}</td>
                    <td className="py-3 px-4 text-center text-gray-600">l</td>
                    <td className="py-3 px-4 text-center text-gray-900 font-medium">{product.specs.solutionTank}</td>
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="py-3 px-4 font-semibold text-gray-700 bg-gray-50">{currentLabels.dirtyWaterTank}</td>
                    <td className="py-3 px-4 text-center text-gray-600">l</td>
                    <td className="py-3 px-4 text-center text-gray-900 font-medium">{product.specs.dirtyWaterTank}</td>
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="py-3 px-4 font-semibold text-gray-700 bg-gray-50">{currentLabels.noise}</td>
                    <td className="py-3 px-4 text-center text-gray-600">dBA</td>
                    <td className="py-3 px-4 text-center text-gray-900 font-medium">{product.specs.noise}</td>
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="py-3 px-4 font-semibold text-gray-700 bg-gray-50">{currentLabels.weight}</td>
                    <td className="py-3 px-4 text-center text-gray-600">Kg</td>
                    <td className="py-3 px-4 text-center text-gray-900 font-medium">{product.specs.weight}</td>
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="py-3 px-4 font-semibold text-gray-700 bg-gray-50">{currentLabels.dimensions}</td>
                    <td className="py-3 px-4 text-center text-gray-600">l x w x h</td>
                    <td className="py-3 px-4 text-center text-gray-900 font-medium">{product.specs.dimensions}</td>
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="py-3 px-4 font-semibold text-gray-700 bg-gray-50">{currentLabels.power}</td>
                    <td className="py-3 px-4 text-center text-gray-600"></td>
                    <td className="py-3 px-4 text-center text-gray-900 font-medium">{product.specs.power}</td>
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="py-3 px-4 font-semibold text-gray-700 bg-gray-50">{currentLabels.driveMotor}</td>
                    <td className="py-3 px-4 text-center text-gray-600">Yes or No</td>
                    <td className="py-3 px-4 text-center text-gray-900 font-medium">{product.specs.driveMotor}</td>
                  </tr>
                  <tr>
                    <td className="py-3 px-4 font-semibold text-gray-700 bg-gray-50">{currentLabels.workingTime}</td>
                    <td className="py-3 px-4 text-center text-gray-600">hr</td>
                    <td className="py-3 px-4 text-center text-gray-900 font-medium">{product.specs.workingTime}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Action Buttons */}
            <div className="space-y-4">
              {product.catalogUrl.startsWith('http') ? (
                <a href={product.catalogUrl} target="_blank" rel="noopener noreferrer" className="block">
                  <Button className="w-full bg-sky-500 hover:bg-sky-600 text-white">
                    <Download className="w-5 h-5 mr-2" />
                    {t('catalog')}
                  </Button>
                </a>
              ) : (
                <Link to={product.catalogUrl}>
                  <Button className="w-full bg-sky-500 hover:bg-sky-600 text-white">
                    <Download className="w-5 h-5 mr-2" />
                    {t('catalog')}
                  </Button>
                </Link>
              )}
              <Link to="/contact">
                <Button variant="outline" className="w-full border-sky-500 text-sky-500 hover:bg-sky-50">
                  {t('contact')}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
